"use client";
import { Snowflake, ThermometerSun, Droplets, Check } from "lucide-react";

interface BestTime {
  SeasonType: string;
  Title: string;
  Description: string;
}

interface BestTimeToVisitSectionProps {
  bestTimes: BestTime[];
}

export default function BestTimeToVisitSection({
  bestTimes,
}: BestTimeToVisitSectionProps) {
  if (!bestTimes || bestTimes.length === 0) return null;

  return (
    <section className="py-28 bg-[#F9F7F4]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl mb-12 text-center text-[#1A1A1A]">
          Best Time to Visit
        </h2>

        <div className="max-w-3xl mx-auto relative">
          <div className="absolute left-6 top-0 bottom-0 w-px bg-[#E6E1DA]" />

          <div className="space-y-14">
            {bestTimes.map((season, index) => (
              <div key={index} className="relative pl-20">
                {/* Icon */}
                <div
                  className={`absolute left-0 top-1 w-12 h-12 rounded-xl flex items-center justify-center ${
                    season.SeasonType === "Winter"
                      ? "bg-gray-100 text-gray-600"
                      : season.SeasonType === "Summer"
                        ? "bg-red-100 text-red-600"
                        : season.SeasonType === "Monsoon"
                          ? "bg-blue-100 text-blue-600"
                          : "bg-green-100 text-green-600"
                  }`}
                >
                  {season.SeasonType === "All Season" && (
                    <Check className="w-6 h-6" />
                  )}
                  {season.SeasonType === "Winter" && (
                    <Snowflake className="w-6 h-6" />
                  )}
                  {season.SeasonType === "Summer" && (
                    <ThermometerSun className="w-6 h-6" />
                  )}
                  {season.SeasonType === "Monsoon" && (
                    <Droplets className="w-6 h-6" />
                  )}
                </div>

                {/* Content */}
                <h3 className="text-xl font-semibold text-[#5A3A1E] mb-2">
                  {season.SeasonType}
                </h3>

                <span
                  className={`inline-block mb-3 px-4 py-1 rounded-full text-sm font-semibold ${
                    season.SeasonType === "Winter"
                      ? "bg-gray-100 text-gray-700"
                      : season.SeasonType === "Summer"
                        ? "bg-red-100 text-red-700"
                        : season.SeasonType === "Monsoon"
                          ? "bg-blue-100 text-blue-700"
                          : "bg-green-100 text-green-700"
                  }`}
                >
                  {season.Title}
                </span>

                <p className="text-[#5A3A1E]/70 leading-relaxed">
                  {season.Description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
